import { render } from "./ArdaStats.vue?vue&type=template&id=6df43f4a"
import script from "./ArdaStats.vue?vue&type=script&lang=js"
export * from "./ArdaStats.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__